<template>
  <div>
    <el-dialog top="2vh" title="Colunas" :visible.sync="dialog" v-loading="loading" width="50%">

      <el-form ref="form" label-width="160px">
        <table class="table">
          <thead>
            <th class="w-33">Colunas</th>
            <th class="w-33">Campo</th>
            <th class="w-33">Valor Planilha</th>
          </thead>
          <tbody>
            <tr v-for="record of data" :key="record.index">
              <td>
                <el-tag type="primary">{{ record.column }}</el-tag>
              </td>
              <td>
                <el-tag type="info">{{ record.field }}</el-tag>
              </td>
              <td>
                <el-input v-model="record.value"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="save">Salvar</el-button>
        <el-button @click="dialog = false">Cancelar</el-button>
      </span>
    </el-dialog>
    <el-alert
      description="Esse processo irá validar todas as linhas da sua planilha, dependendo da quantidade de linhas ele pode demorar um pouco, por favor aguarde!"
      type="warning" :closable="false" />
    <el-row :gutter="5">
      <el-table :data="tableData" style="width: 100%" v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="Linha" width="100" />
        <el-table-column label="Status" property="status" width="150">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 'Erro' ? 'danger' : scope.row.status === 'Sucesso' ? 'success' : 'info'">{{
                scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Resultado" property="result" />
        <el-table-column label="#" width="140">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 'Erro'" type="info" icon="el-icon-edit"
              @click="correct(scope.row)">Corrigir</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row :gutter="5" style="margin-top: 50px">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6" :offset="11" style="display: flex; justify-content: center">
        <el-button @click="back()">Voltar</el-button>
        <el-button type="primary" @click="create()">Criar destinatários</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "ValidateRowsDelivery",
  props: ["fileData", "columnData", "customer"],
  data() {
    return {
      tableData: [],
      prepostList: [],
      data: [],
      current: null,
      loading: false,
      dialog: false,
      dialogdc: false,
    };
  },
  mounted() {
    const vm = this;
    if (vm.fileData.length === 0 || vm.columnData.length === 0) return false;

    for (let i = 0; i < vm.fileData.length; i++) {
      const record = vm.fileData[i];
      vm.tableData.push({ index: i, status: "Aguardando", result: "", data: record, delivery: null });
    }
    vm.loading = true;
    vm.fileData.map(async (data, index) => {
      await vm.setDeliveryData(data, index);
      return true;
    });
  },
  methods: {
    tableRowClassName: function (row, rowIndex) {
      if (row.status === "Erro") {
        return "warning-row";
      } else if (row.status === "Sucesso") {
        return "success-row";
      }
      return "";
    },
    back() {
      const vm = this;
      vm.$emit("back");
    },
    create() {
      const vm = this;
      const success = vm.tableData.filter(x => x.status === 'Sucesso');
      if (success && success.length === 0) {
        return this.$message({
          type: "error",
          message: "Nenhuma linha da planilha foi validada com sucesso, sem destinatários para criação!",
        });
      }
      const errors = vm.tableData.filter(x => x.status === 'Erro');
      if (errors && errors.length > 0) {
        this.$confirm(
          `Existem linhas ainda com erros, para essas linhas não serão criadas os destinatários, deseja continuar?`,
          i18n.tc("aviso"),
          {
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            type: i18n.tc("aviso"),
            center: true,
          }
        ).then(() => {
          vm.$emit("create", success);
          vm.$emit("next");
        });

      } else {
        vm.$emit("create", success);
        vm.$emit("next");
      }
    },
    correct(record) {
      const vm = this;
      const fields = Object.keys(record.data);
      vm.data = [];
      for (let i = 0; i < fields.length; i++) {
        vm.data.push({
          index: i,
          column: `Coluna ${vm.generate(i).toUpperCase()}`,
          value: record.data[fields[i]],
          field: fields[i]
        });
      }
      vm.current = record;
      vm.dialog = true;
    },
    save() {
      const vm = this;
      let newData = {};
      vm.loading = true;
      for (const record of vm.data) {
        newData[record.field] = record.value;
      }
      vm.tableData[vm.current.index].data = newData;
      vm.setDeliveryData(newData, vm.current.index);
      vm.dialog = false;
    },
    generate(a) {
      var b = [a], sp, out, i, div;
      sp = 0;
      while (sp < b.length) {
        if (b[sp] > 25) {
          div = Math.floor(b[sp] / 26);
          b[sp + 1] = div - 1;
          b[sp] %= 26;
        }
        sp += 1;
      }

      out = "";
      for (i = 0; i < b.length; i += 1) {
        out = String.fromCharCode('a'.charCodeAt(0) + b[i]) + out;
      }

      return out;
    },
    async setDeliveryData(data, index) {
      const vm = this;
      let deliveryData = {
        customer: null,
        name: '',
        cep: '',
        extent: '',
        address: '',
        city: '',
        state: '',
        neighborhood: '',
        number: '',
        mobile: '',
        phone: '',
        error: '',
      };

      try {

        if (data.CEP && data.CEP.length < 8) {
          data.CEP = data.CEP.padStart(8, "0");
        }

        deliveryData.name = data.NOME || '';
        deliveryData.cep = data.CEP;
        deliveryData.extent = data.COMPLEMENTO || '';
        deliveryData.mobile = data.CELULAR || '';
        deliveryData.phone = data.TELEFONE || '';
        deliveryData.number = data.NUMERO || '';
        deliveryData.mail = data.EMAIL || '';

        try {
          const response = await PostOfficeService.zipcode(data.CEP, "delivery");
          if (response) {
            deliveryData.address = data.ENDERECO ? data.ENDERECO : response.end;
            deliveryData.neighborhood = data.BAIRRO ? data.BAIRRO : response.bairro;
            deliveryData.city = data.CIDADE ? data.CIDADE : response.cidade;
            deliveryData.state = data.UF ? data.UF : response.uf;
          }
        } catch (e) {
          deliveryData.error = `CAMPO "CEP" ERRO: ${e}`;
        }
      } catch (e) {
        deliveryData.error = `ERRO: ${e}`;
      }
      deliveryData.customer = vm.customer;

      Promise.all([deliveryData])
        .then((res) => {
          const response = res[0];
          vm.tableData[index].delivery = response;
          vm.tableData[index].status = response.error ? "Erro" : "Sucesso";
          vm.tableData[index].result = response.error ? response.error : "";
        })
        .catch((err) => {
          vm.tableData[index].status = "Erro";
          vm.tableData[index].result = err
        }).finally(() => vm.loading = false);
    },
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.w-50 {
  width: 50%;
}
</style>
